import { LinkButton } from "@lululemon/ufs-shared";

export default LinkButton;
